export function capitalizeWords(text?: string) {
  return (text || '')
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()
    })
    .join(' ')
}
